"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var react_emotion_1 = require("react-emotion");

exports.injectGlobal = react_emotion_1.injectGlobal;

exports.css = function (strings) {
  var interps = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    interps[_i - 1] = arguments[_i];
  }

  return [strings.slice(), interps];
};

exports.cssToInline = function (css) {
  if (typeof css !== 'string') return {};
  var rules = css.replace(/\s+/g, ' ').split(/;/);
  rules.pop();
  return rules.reduce(function (styles, rule) {
    var _a;

    var _b = rule.split(':'),
        name = _b[0],
        value = _b[1];

    return __assign({}, styles, (_a = {}, _a[lodash_1.default.camelCase(name)] = (value || '').trim(), _a));
  }, {});
};

function round(value) {
  return Math.round(value * 10) / 10;
}

exports.round = round;

function getScalar(value) {
  if (value === true) return 1;else if (value === false) return 0;else return round(parseFloat(value));
}

exports.getScalar = getScalar;

function joinTemplates(A, B) {
  var ABody = A[0].slice(0, A[0].length - 1),
      AEnd = A[0][A[0].length - 1] === undefined ? '' : A[0][A[0].length - 1],
      BStart = B[0][0] === undefined ? '' : B[0][0],
      BBody = B[0].slice(1);
  return [ABody.concat([AEnd + BStart], BBody), A[1].concat(B[1])];
}

exports.joinTemplates = joinTemplates;

function interpolateTemplate(rawTemplate) {
  var strings = rawTemplate[0],
      values = rawTemplate[1];
  return strings.map(function (chunk, i) {
    return values[i - 1] ? values[i - 1] + chunk : chunk;
  }).join('');
}

exports.interpolateTemplate = interpolateTemplate;

function mergeClasses(A, B) {
  return {
    styles: joinTemplates(A.styles, B.styles),
    props: Object.assign({}, A.props, B.props),
    inline: Object.assign({}, A.inline || {}, B.inline || {})
  };
}

exports.mergeClasses = mergeClasses;